import type { ProgressState } from "../application/progress-state";
import { motionConfig, type MotionProfile } from "../config/motion-config";

export interface MotionPreferenceStore {
  getState(): ProgressState;
}

export class MotionPreference {
  public constructor(
    private readonly store: MotionPreferenceStore,
    private readonly root: HTMLElement,
  ) {
    this.sync();
  }

  public getProfile(): MotionProfile {
    return this.store.getState().preferences.reducedMotion
      ? motionConfig.reduced
      : motionConfig.standard;
  }

  public sync(): void {
    const profile = this.getProfile();
    this.root.dataset.motion =
      profile === motionConfig.reduced ? "reduced" : "standard";
    this.root.style.setProperty(
      "--motion-guidance-duration",
      `${String(profile.guidanceDurationMs)}ms`,
    );
    this.root.style.setProperty(
      "--motion-guidance-static-offset",
      `${String(profile.guidanceStaticOffsetPx)}px`,
    );
    this.root.style.setProperty(
      "--motion-guidance-travel",
      `${String(profile.guidanceTravelPx)}px`,
    );
    this.root.style.setProperty(
      "--motion-particle-duration",
      `${String(profile.particleDurationMs)}ms`,
    );
    this.root.style.setProperty(
      "--motion-particle-opacity",
      String(profile.particleOpacity),
    );
    this.root.style.setProperty(
      "--motion-particle-travel",
      `${String(profile.particleTravelPx)}px`,
    );
    this.root.style.setProperty(
      "--motion-pulse-duration",
      `${String(profile.pulseDurationMs)}ms`,
    );
    this.root.style.setProperty(
      "--motion-pulse-scale",
      String(profile.pulseScale),
    );
    this.root.style.setProperty(
      "--motion-round-pulse-scale",
      String(profile.roundPulseScale),
    );
    this.root.style.setProperty(
      "--motion-screen-distance",
      `${String(profile.screenTransitionDistancePx)}px`,
    );
    this.root.style.setProperty(
      "--motion-screen-duration",
      `${String(profile.screenTransitionDurationMs)}ms`,
    );
  }
}
